 
import type { ComputedRef, ModelRef } from 'vue';
import { computed } from 'vue';
import type { User } from 'src/modules/User/models/User';
import type { Profile } from 'src/modules/User/models/Profile';

 
export function useUserSettings(user: ModelRef<Partial<User> | undefined>) {
  // firstname/lastname are common identity on the user now; `profile` holds only
  // cold contact data (address/phone). Name is edited directly on the user.
  const profile: ComputedRef<Partial<User['profile']>> = computed(
    () => user.value?.profile ?? {},
  );

  if (user.value && !user.value?.profile) {
    Object.assign(user.value, { profile: {} });
  }

  if (!profile?.value?.address?.[0] && user?.value?.profile) {
    user.value.profile.address = [
      {
        street: '',
        city: '',
        zip: '',
        country: 'Ukraine',
        type: 'Home',
      },
    ];
  }

  const address: ComputedRef<Profile['address'] | undefined> = computed(
    () => profile?.value?.address,
  );

  if (!profile?.value?.phone?.[0] && user?.value?.profile) {
    user.value.profile.phone = [
      {
        number: '',
        type: 'Mobile',
      },
    ];
  }

  const phone: ComputedRef<Profile['phone'] | undefined> = computed(
    () => profile?.value?.phone,
  );

  return {
    profile,
    address: address?.value?.[0],
    phone: phone?.value?.[0],
  };
}
